import config from '../config/config';

const CLIPBOARD_MESSAGES = config.clipboard.messages;

const TEXTAREA_TAG = 'textarea';
const EXEC_COMMAND_COPY = 'copy';

const ATTR_READONLY = 'readonly';
const ATTR_ARIA_HIDDEN = 'aria-hidden';
const CLASS_CLIPBOARD_OFFSCREEN = 'clipboard-offscreen';

/**
 * クリップボード操作関数
 * @param {string} text - コピーするテキスト
 * @param {string} action - アクション名
 */
export const copyToClipboard = (text, action) => {
  const copyText = String(text ?? '');
  if (navigator.clipboard && window.isSecureContext) {
    // モダンAPIが使える場合
    return navigator.clipboard.writeText(copyText)
      .then(() => ({
        success: true,
        message: CLIPBOARD_MESSAGES[action] || CLIPBOARD_MESSAGES.success
      }))
      .catch(err => {
        // モダンAPIで失敗した場合もフォールバック
        const fallbackSuccess = fallbackCopyTextToClipboard(copyText);
        return fallbackSuccess
          ? {
            success: true,
            message: CLIPBOARD_MESSAGES[action] || CLIPBOARD_MESSAGES.success
          }
          : {
            success: false, error: err
          };
      });
  } else {
    // モダンAPIが使えない場合は即フォールバック
    const fallbackSuccess = fallbackCopyTextToClipboard(copyText);
    return Promise.resolve(
      fallbackSuccess
        ? {
          success: true,
          message: CLIPBOARD_MESSAGES[action] || CLIPBOARD_MESSAGES.success
        }
        : {
          success: false,
          error: new Error(CLIPBOARD_MESSAGES.fallbackError)
        }
    );
  }
};

/**
 * フォールバック: 古いブラウザ向けのクリップボードコピー
 * @param {string} copyText - コピーするテキスト
 * @returns {boolean} コピー成功したかどうか
 */
const fallbackCopyTextToClipboard = (copyText) => {
  const textArea = document.createElement(TEXTAREA_TAG);
  textArea.value = copyText;

  textArea.setAttribute(ATTR_READONLY, '');
  textArea.setAttribute(ATTR_ARIA_HIDDEN, 'true');
  textArea.classList.add(CLASS_CLIPBOARD_OFFSCREEN);
  document.body.appendChild(textArea);

  try {
    textArea.focus();
    textArea.select();
    try {
      textArea.setSelectionRange(0, copyText.length);
    } catch (e) {
    }
  } catch (e) {
  }

  let success = false;
  try {
    success = document.execCommand(EXEC_COMMAND_COPY);
  } catch (err) {
    success = false;
  }

  document.body.removeChild(textArea);
  return success;
};
